import { apiClient } from './client';
import type { AccountType, AccountTypeWrite } from '@/types/oscar';

/**
 * Account Type config (oscar/api/Functions/AccountTypesFunctions.cs). The
 * categorisation for the unified People / Accounts view. Reads for any Oscar
 * role; writes are admin-only. `activeOnly` limits the list to live categories
 * (for pickers).
 */
export function listAccountTypes(activeOnly = false, signal?: AbortSignal): Promise<AccountType[]> {
  const q = activeOnly ? '?activeOnly=1' : '';
  return apiClient.get<AccountType[]>(`/api/account-types${q}`, signal);
}
export function createAccountType(body: AccountTypeWrite): Promise<AccountType> {
  return apiClient.post<AccountType>('/api/account-types', body);
}
export function updateAccountType(id: number, body: AccountTypeWrite): Promise<AccountType> {
  return apiClient.patch<AccountType>(`/api/account-types/${id}`, body);
}
export function deleteAccountType(id: number): Promise<unknown> {
  return apiClient.post(`/api/account-types/${id}/delete`);
}
